import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { ArrowUpward, Folder } from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelection, useTreePicker } from "../../hooks/index.js";
/**
 * Represents a list picker component.
 */
export function CopyMoveTreePicker(props) {
  const {
    selection,
    setSelection
  } = useSelection();
  const {
    items,
    navigateTo,
    isLoading,
    error
  } = useTreePicker({
    repository: props.repository,
    currentPath: props.currentPath,
    selectionRoots: props.selectionRoots,
    allowMultiple: false,
    itemsODataOptions: props.itemsODataOptions,
    parentODataOptions: props.parentODataOptions
  });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [parentNode, setParentNode] = useState([]);
  useEffect(() => {
    const setDefaultParent = setTimeout(() => {
      setSelection([props.currentParent]);
    }, 50);
    return () => {
      clearTimeout(setDefaultParent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onClickSelectListItem = useCallback((_event, index, node) => {
    if (selectedIndex === index) {
      setSelectedIndex(0);
      if (parentNode.length === 0) {
        var _props$setDestination, _props$currentParent;
        setSelection([props.currentParent]);
        (_props$setDestination = props.setDestination) === null || _props$setDestination === void 0 ? void 0 : _props$setDestination.call(props, (_props$currentParent = props.currentParent) === null || _props$currentParent === void 0 ? void 0 : _props$currentParent.DisplayName);
      } else {
        var _props$setDestination2;
        setSelection(parentNode);
        (_props$setDestination2 = props.setDestination) === null || _props$setDestination2 === void 0 ? void 0 : _props$setDestination2.call(props, parentNode[0].DisplayName);
      }
    } else {
      setSelectedIndex(index);
      if (!node.isParent) {
        var _selection$;
        const newSelection = [];
        if (newSelection.length === selection.length || ((_selection$ = selection[0]) === null || _selection$ === void 0 ? void 0 : _selection$.Id) !== node.Id) {
          var _props$setDestination3;
          newSelection.push(node);
          (_props$setDestination3 = props.setDestination) === null || _props$setDestination3 === void 0 ? void 0 : _props$setDestination3.call(props, node.DisplayName);
        }
        setSelection(newSelection);
      }
    }
  }, [selectedIndex, parentNode, setSelection, props, selection]);
  const onDoubleClickHandler = useCallback((_event, node) => {
    if (node.IsFolder || node.isParent) {
      var _props$onTreeNavigati, _props$setDestination4;
      navigateTo(node);
      (_props$onTreeNavigati = props.onTreeNavigation) === null || _props$onTreeNavigati === void 0 ? void 0 : _props$onTreeNavigati.call(props, node.Path);
      setSelection([node]);
      setParentNode([node]);
      (_props$setDestination4 = props.setDestination) === null || _props$setDestination4 === void 0 ? void 0 : _props$setDestination4.call(props, node.DisplayName);
    }
  }, [navigateTo, props, setSelection]);
  const defaultRenderer = useCallback(item => {
    var _props$renderIcon;
    if (item.isParent) {
      return /*#__PURE__*/React.createElement(ListItem, {
        "data-test": "picker-up",
        key: item.Id,
        button: true
      }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ArrowUpward, null)), /*#__PURE__*/React.createElement(ListItemText, {
        primary: '[..]'
      }));
    }
    const labelId = `checkbox-list-label-${item.Id}`;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.Id,
      button: true,
      selected: selectedIndex === item.Id,
      "data-test": `picker-checkbox-item-${item.Name.replace(/\s+/g, '-').toLowerCase()}`,
      onClick: e => onClickSelectListItem(e, item.Id, item)
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, ((_props$renderIcon = props.renderIcon) === null || _props$renderIcon === void 0 ? void 0 : _props$renderIcon.call(props, item)) || /*#__PURE__*/React.createElement(Folder, {
      style: {
        color: 'primary'
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: labelId,
      primary: item.DisplayName,
      secondary: item.Path.replace(new RegExp('^/Root', 'g'), '')
    }));
  }, [onClickSelectListItem, props, selectedIndex]);
  const renderItem = props.renderItem || defaultRenderer;
  if (isLoading) {
    var _props$renderLoading;
    return ((_props$renderLoading = props.renderLoading) === null || _props$renderLoading === void 0 ? void 0 : _props$renderLoading.call(props)) || null;
  }
  if (error) {
    var _props$renderError;
    return ((_props$renderError = props.renderError) === null || _props$renderError === void 0 ? void 0 : _props$renderError.call(props, error.message)) || /*#__PURE__*/React.createElement(Typography, {
      color: "error",
      variant: "caption"
    }, error.message);
  }
  return /*#__PURE__*/React.createElement(List, null, items === null || items === void 0 ? void 0 : items.map(item => /*#__PURE__*/React.createElement("div", {
    onDoubleClick: e => onDoubleClickHandler(e, item),
    key: item.Id
  }, renderItem(item))));
}
//# sourceMappingURL=copy-move-tree-picker.js.map